// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pplive":"pplive-Fdn9J0vd","list":"list-2Zz_SVC-"};